import { BasePayloadMapper, normalizeValue, omitNullValues } from '@ps/utils';

import { GetSurveysParams } from '../dtos/invoice-survey.dto';
import { GetSurveysFilters } from '../../models/invoice-survey.model';

const DEFAULT_PARAMS: Pick<GetSurveysParams, 'UI' | 'targeting' | 'limit'> = {
  UI: 1,
  targeting: 0,
  limit: 20,
};

interface Filters extends GetSurveysFilters {
  page: number;
}

export class SurveyPayloadMapper extends BasePayloadMapper<
  Filters,
  Partial<GetSurveysParams>
> {
  public toPayload(filters: Filters): Partial<GetSurveysParams> {
    return omitNullValues({
      ...DEFAULT_PARAMS,
      buyerId: filters.buyerId,
      searchPo: normalizeValue(filters.billingPo),
      fromDate: normalizeValue(filters.startDate),
      toDate: normalizeValue(filters.endDate),
      isMultiBuyer: filters.isMultiBuyer || null,
      status: normalizeValue(filters.statuses)?.join(','),
      surveyIds: normalizeValue(filters.surveyIds),
      searchTitle: normalizeValue(filters.title),
      page: filters.page,
    });
  }
}
